const isSubSet = <T>(set: Set<T>, subSet: Set<T>) => {
  return [...subSet].every((slug) => set.has(slug));
};

export default isSubSet;
